import { MouseEvent } from "react";
import { Box } from "@mui/material";
import { IWfLinkProps, WfLink } from "src/components/base/wf-link";

interface IMenuLinkProps extends IWfLinkProps {
    hasChildElements: boolean;
}

const menuItemBoxSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "80px",
    px: 2,
    position: "relative",
    cursor: "default",
} as const;

export const MenuLink = ({ children, hasChildElements, href, target, ...props }: IMenuLinkProps) => {
    const menuItemProps = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        h: 10,
        px: 2,
        role: "menuitem",
        cursor: hasChildElements ? "default" : "pointer",
        onClick: (event: MouseEvent<HTMLDivElement | HTMLAnchorElement>) => event.currentTarget.blur(),
        onAuxClick: (event: MouseEvent<HTMLDivElement | HTMLAnchorElement>) => event.currentTarget.blur(),
        pos: "relative",
    } as const;
    const menuLinkProps = { href, target, className: "gtm-nav-menu__link", variant: "unstyled" };
    return hasChildElements ? (
        <Box component="span" role="menuitem" sx={menuItemBoxSx}>
            {children}
        </Box>
    ) : (
        <WfLink {...menuLinkProps} {...menuItemProps} {...props}>
            {children}
        </WfLink>
    );
};
